// Prybar persists per-device state under "prybar-*" localStorage keys; the
// "prybar-prev-session-<userId>" key holds the member's last health
// conversation, so on shared browsers it must never outlive the session.
const PRYBAR_KEY_PREFIX = "prybar-";
const PREV_SESSION_KEY_PREFIX = "prybar-prev-session-";

function removeMatchingKeys(matches: (key: string) => boolean): void {
  try {
    const doomed: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && matches(key)) doomed.push(key);
    }
    for (const key of doomed) localStorage.removeItem(key);
  } catch {
    // storage unavailable: nothing was persisted, so nothing to clear
  }
}

export function clearPrybarStorage(): void {
  removeMatchingKeys((key) => key.startsWith(PRYBAR_KEY_PREFIX));
}

export function purgeOtherUsersPrybarSessions(userId: string): void {
  const ownKey = `${PREV_SESSION_KEY_PREFIX}${userId}`;
  removeMatchingKeys((key) => key.startsWith(PREV_SESSION_KEY_PREFIX) && key !== ownKey);
}
